"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLocationDto = instanceOfLocationDto;
exports.LocationDtoFromJSON = LocationDtoFromJSON;
exports.LocationDtoFromJSONTyped = LocationDtoFromJSONTyped;
exports.LocationDtoToJSON = LocationDtoToJSON;
exports.LocationDtoToJSONTyped = LocationDtoToJSONTyped;
/**
 * Check if a given object implements the LocationDto interface.
 */
function instanceOfLocationDto(value) {
    return true;
}
function LocationDtoFromJSON(json) {
    return LocationDtoFromJSONTyped(json, false);
}
function LocationDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'displayAddress': json['displayAddress'] == null ? undefined : json['displayAddress'],
        'streetAddress': json['streetAddress'] == null ? undefined : json['streetAddress'],
        'suburb': json['suburb'] == null ? undefined : json['suburb'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'country': json['country'] == null ? undefined : json['country'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
    };
}
function LocationDtoToJSON(json) {
    return LocationDtoToJSONTyped(json, false);
}
function LocationDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'displayAddress': value['displayAddress'],
        'streetAddress': value['streetAddress'],
        'suburb': value['suburb'],
        'city': value['city'],
        'state': value['state'],
        'country': value['country'],
        'postalCode': value['postalCode'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
    };
}
